import { Link } from "react-router-dom";
import styled from "styled-components";

const SingleSnackCard = ({ to, snackImage }) => {
  return (
    <HoveredSnack className="card transition-all duration-200">
      <Link to={to}>
        <img src={snackImage} className="max-w-[230px] w-full m-auto h-full" />
      </Link>
    </HoveredSnack>
  );
};

const HoveredSnack = styled.div`
  &:hover {
    transform: translateY(-4px);
  }
`;
export default SingleSnackCard;
